export default __webpack_public_path__ + "static/media/testifySeven.f6325c42.png";